// Shared form-field definitions for Search By Characteristic.
// Sama pola dengan materialSearchFields.js/serviceSearchFields.js — dipakai CataloguerForm.vue
// untuk sinkronisasi URL <-> smFormData saat isSearchCharacteristicMode.
// Payload dari CharacteristicSearchForm.vue: { inc, item_type, characteristics: [{characteristic, characteristic_value}] }

export const initialFormData = {
  inc: "",
  item_type: "",
  client: "",
  characteristics: [],
};

export const queryFields = Object.keys(initialFormData);
